import { render, staticRenderFns } from "./GridImport.vue?vue&type=template&id=a21dce20&scoped=true&"
import script from "./GridImport.vue?vue&type=script&lang=js&"
export * from "./GridImport.vue?vue&type=script&lang=js&"
import style0 from "./GridImport.vue?vue&type=style&index=0&id=a21dce20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21dce20",
  null
  
)

/* custom blocks */
import block0 from "./GridImport.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports